import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "product-media",
  class ProductMedia extends WYATTElement {
    constructor() {
      super();

      this.desktopContainer = this.querySelector(".product-media--desktop");
      this.primaryContainer = this.desktopContainer.querySelector(
        ".product-media__primary",
      );
      this.primaryItems = this.desktopContainer.querySelectorAll(
        ".product-media__primary-item",
      );
      this.secondaryContainer = this.desktopContainer.querySelector(
        ".product-media__secondary",
      );
      this.secondaryItems = this.secondaryContainer.querySelectorAll(
        ".product-media__secondary-item",
      );
      this.secondaryButtons = this.desktopContainer.querySelectorAll(
        ".product-media__secondary-button",
      );
      this.imageCount = this.primaryItems.length;

      this.openModalButtons = this.desktopContainer.querySelectorAll(
        "[data-product-media-modal-open]",
      );

      this.modal = this.querySelector(this.config.modalSelector);
      this.modalPrimarySlider = this.modal.querySelector(
        "[data-product-media-modal-primary-slider]",
      );
      this.modalSecondarySlider = this.modal.querySelector(
        "[data-product-media-modal-secondary-slider]",
      );

      this.waitForScrollEnd = false;

      this.bindEvents();
    }

    bindEvents() {
      this.primaryItems.forEach((item, index) => {
        this.initializeIntersectionObserver(item, index);
      });

      this.secondaryButtons.forEach((button, index) => {
        button.addEventListener("click", (event) =>
          this.handleSecondaryButtonClick(event, index),
        );
      });

      window.addEventListener("scrollend", () => {
        this.waitForScrollEnd = false;
      });

      this.openModalButtons.forEach((button) => {
        button.addEventListener(
          "click",
          this.handleViewAllButtonClick.bind(this),
        );
      });
    }

    initializeIntersectionObserver(item, index) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.waitForScrollEnd) {
              this.activateSecondaryItem(index);
            }
          });
        },
        {
          threshold: 0.5,
        },
      );

      observer.observe(item);
    }

    handleSecondaryButtonClick(event, index) {
      event.preventDefault();
      this.scrollToPrimaryItem(index);
    }

    handleViewAllButtonClick(event) {
      event.preventDefault();
      const index = Number(event.currentTarget.dataset.productMediaModalOpen);

      this.modal.open();
      this.modalPrimarySlider.goTo(index, "instant");
      this.modalSecondarySlider.goTo(index, "instant");
    }

    scrollToPrimaryItem(index) {
      const { offsetTop } = this.primaryItems[index];
      this.primaryContainer.scrollTo({ top: offsetTop, behavior: "smooth" });
    }

    activateSecondaryItem(index) {
      this.deactivateSecondaryItems();
      this.secondaryItems[index].setAttribute("active", true);
    }

    deactivateSecondaryItems() {
      const activeItems = Array.from(this.secondaryItems).filter((item) =>
        item.getAttribute("active"),
      );

      activeItems.forEach((item) => {
        item.removeAttribute("active");
      });
    }
  },
);
